import { useState, useRef, useEffect } from "react";
import "./ProfileSettings.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APIClient } from "smartassess-api-lib";
import ProfileIcon from "../../utils/Images/ProfileIcon";
import NotificationIcon from "../../utils/Images/NotificationIcon";
import SettingsIcon from "../../utils/Images/SettingsIcon";
import SignoutIcon from "../../utils/Images/SignoutIcon";
import DummyUser from "../../utils/Images/DummyUser";
import i18n from "../../i18nConfig";
import NewSkills from "../../utils/Images/NewSkills";

interface ProfileSettingsProps {
  email: any;
  profileData: any;
}
const ProfileSettings = ({ email, profileData }: ProfileSettingsProps) => {
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const popoverRef: any = useRef(null);
  const iconRef: any = useRef(null);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentlanguage = i18n.language;
  const togglePopover = () => {
    setPopoverVisible((prevVisible) => !prevVisible);
  };
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setPopoverVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  //function to logout
  const handleLogout = () => {
    localStorage.removeItem("adminAccessToken");
    localStorage.removeItem("adminEmail");
    localStorage.removeItem("userId");
    APIClient.setApiToken("");
    sessionStorage.clear();
    navigate("/");
  };
  return (
    <div className="profileSettings">
      <div ref={iconRef} onClick={togglePopover}>
        {profileData?.profilePic ? (
          <div>
            <img
              src={profileData?.profilePic}
              alt="Logo"
              className="companyLogo"
            />
          </div>
        ) : email ? (
          <div className="logoPlace">
            {email?.charAt(0).toLocaleUpperCase()}
          </div>
        ) : (
          <div className="logoPlace usericon">
            <DummyUser width={20} height={20} />
          </div>
        )}
      </div>
      {isPopoverVisible && (
        <div className="popover" ref={popoverRef}>
          <div className="popoverHeader">
            <div className="logo-name-sec">
              {profileData?.profilePic ? (
                <img
                  src={profileData?.profilePic}
                  alt="Logo"
                  className="companyLogo"
                />
              ) : email ? (
                <div className="profile-icon companyLogo">
                  {email?.charAt(0).toLocaleUpperCase()}
                </div>
              ) : (
                <div className="usericon">
                  <DummyUser width={25} height={25} />
                </div>
              )}
              <div className="companyName">
                <strong>{t("GENERAL.ADMIN")}</strong>
                <div className="emailDateSection">
                  <span>{profileData?.email ?? email}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="popoverBody">
            <div className="tab-item popoverItem ">
              <ProfileIcon />
              <div>{t("GENERAL.PROFILE")}</div>
            </div>
            <div className="tab-item popoverItem">
              <NotificationIcon />
              <div>{t("GENERAL.NOTIFICATION")}</div>
            </div>
            <div className="tab-item popoverItem">
              <SettingsIcon />
              <div>{t("GENERAL.SETTINGS")}</div>
            </div>
            <div
              className="tab-item popoverItem"
              onClick={() => {
                setPopoverVisible(false);
                navigate(`/${currentlanguage}/unmatched-skills`);
              }}
            >
              <NewSkills />
              <div>{t("GENERAL.NEW_SKILLS")}</div>
            </div>
            <hr />
            <div className="tab-item popoverItem" onClick={handleLogout}>
              <SignoutIcon />
              <div>{t("GENERAL.LOGOUT")}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileSettings;
